/**
 * Custom error types for bktide CLI
 */
export { AuthenticationError } from './AuthenticationError.js';
export { GuidanceError } from './GuidanceError.js';
